import api from './api';
import { ApiResponse, ExamType, ExamTypeFormData } from '../types';

export const examTypeService = {
  // Get all exam types
  getExamTypes: async (params?: {
    page?: number;
    limit?: number;
    search?: string;
    schoolId?: string;
  }) => {
    const response = await api.get<ApiResponse<{ examTypes: ExamType[]; pagination: any }>>('/exam-types', { params });
    return response.data;
  },

  // Get exam type by ID
  getExamTypeById: async (id: string) => {
    const response = await api.get<ApiResponse<ExamType>>(`/exam-types/${id}`);
    return response.data;
  },

  // Create new exam type
  createExamType: async (data: ExamTypeFormData) => {
    const response = await api.post<ApiResponse<ExamType>>('/exam-types', data);
    return response.data;
  },

  // Update exam type
  updateExamType: async (id: string, data: ExamTypeFormData) => {
    const response = await api.put<ApiResponse<ExamType>>(`/exam-types/${id}`, data);
    return response.data;
  },

  // Delete exam type
  deleteExamType: async (id: string) => {
    const response = await api.delete<ApiResponse>(`/exam-types/${id}`);
    return response.data;
  },
};
